var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQrCodeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.597,
    height: 19.515,
    viewBox: "0 0 19.597 19.515",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#06233d;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.333 0.333)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.251 -0.251)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,0V6.453H6.453V0ZM4.934,4.934H1.518V1.518H4.934Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.117 2.117)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 1.715,
    height: 1.715
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.73 -0.251)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M342,0V6.453h6.453V0Zm4.934,4.934h-3.416V1.518h3.416Z",
    transform: "translate(-342)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.099 2.117)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 1.715,
    height: 1.715
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.251 12.73)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,342v6.453H6.453V342Zm4.934,4.934H1.518v-3.416H4.934Z",
    transform: "translate(0 -342)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.117 15.099)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 1.715,
    height: 1.715
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.382 7.261)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 1.47,
    height: 1.47
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.785 8.744)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M81.518,238.518V237H80v1.518h1.48v1.518H83v-1.518Z",
    transform: "translate(-80 -237)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.445 2.607)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 1.47,
    height: 1.47
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.261 1.382)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 1.715,
    height: 2.695
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.976 -0.333)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 1.47,
    height: 1.715
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.34 4.189)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M201.518,117v1.518H200v1.518h3.036V117Z",
    transform: "translate(-200 -117)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.34 8.744)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M203.036,241.479V240h-1.518v-3H200v3.036h1.518v1.48h1.518V243h3.036v-1.518Z",
    transform: "translate(-200 -237)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.445 7.261)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 1.47,
    height: 2.94
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.413 7.226)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M364.251,198.48V197H361.48v1.518H360v1.518h1.518v1.48h4.251V198.48Zm0,1.518h-2.733v-1.48h2.733Z",
    transform: "translate(-360 -197)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.549 13.14)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 1.715,
    height: 3.184
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.915 10.2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 1.47,
    height: 1.47
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.385 14.854)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 1.47,
    height: 1.47
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.855 13.14)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 1.715,
    height: 1.715
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.931 16.26)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M400,435v2.923h1.518v-1.4h1.215V435Z",
    transform: "translate(-400 -435)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.261 13.14)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 1.715,
    height: 2.94
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.858 16.146)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M243.036,433.518V432H240v3.036h1.518v-1.518H243v1.518h1.518v-1.518Z",
    transform: "translate(-240 -432)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.321 7.261)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 2.94,
    height: 1.47
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.333 8.731)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 1.715,
    height: 2.94
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCodeIcon);
export default __webpack_public_path__ + "static/media/qr-code-icon.55ec07887f12ee748181e4f92914e683.svg";
export { ForwardRef as ReactComponent };